import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Box from '@deliveroo/icon-set/react/Box';
import CheckBoxFill from '@deliveroo/icon-set/react/CheckBoxFill';
import Icon from '@deliveroo/consumer-component-library/components/Icon';

import styles from './styles.scss';

export default function Input(props) {
  const inputProps = Object.assign({}, props);

  const className = classnames(props.className, styles[props.type]);

  delete inputProps.className;

  return (
    <Fragment>
      <input {...inputProps} className={className} />

      {props.type === 'checkbox' && (
        <Fragment>
          <span className={classnames(styles.icon, styles['unchecked-icon'])} aria-hidden>
            <Icon component={Box} />
          </span>
          <span className={classnames(styles.icon, styles['checked-icon'])} aria-hidden>
            <Icon component={CheckBoxFill} />
          </span>
        </Fragment>
      )}
    </Fragment>
  );
}

Input.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['radio', 'checkbox']).isRequired, // The only ones supported at the moment, add styles if you want more
};

Input.defaultProps = {
  className: null,
};
